"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNode = exports.isValidNode = exports.filterNodes = exports.getPreviousNode = exports.getChildNodes = exports.wrap = exports.getNodeId = exports.clear = exports.getOrCreateNodeId = void 0;
var map_1 = __importDefault(require("licia/map"));
var filter_1 = __importDefault(require("licia/filter"));
var each_1 = __importDefault(require("licia/each"));
var trim_1 = __importDefault(require("licia/trim"));
var contain_1 = __importDefault(require("licia/contain"));
var extend_1 = __importDefault(require("licia/extend"));
var util_1 = require("./util");
var nodes = new Map();
var nodeIds = new Map();
var id = 1;
function getOrCreateNodeId(node) {
    var nodeId = nodeIds.get(node);
    if (nodeId)
        return nodeId;
    nodeId = id++;
    nodeIds.set(node, nodeId);
    nodes.set(nodeId, node);
    return nodeId;
}
exports.getOrCreateNodeId = getOrCreateNodeId;
function clear() {
    nodes.clear();
    nodeIds.clear();
}
exports.clear = clear;
function getNodeId(node) {
    return nodeIds.get(node);
}
exports.getNodeId = getNodeId;
function wrap(node, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.depth, depth = _c === void 0 ? 1 : _c;
    var nodeId = getOrCreateNodeId(node);
    var ret = {
        nodeName: node.nodeName,
        nodeType: node.nodeType,
        localName: node.localName || '',
        nodeValue: node.nodeValue || '',
        nodeId: nodeId,
        backendNodeId: nodeId,
    };
    if (node.parentNode) {
        ret.parentId = getOrCreateNodeId(node.parentNode);
    }
    if (node.nodeType === 10) {
        return (0, extend_1.default)(ret, {
            publicId: '',
            systemId: '',
        });
    }
    if (node.attributes) {
        var attributes_1 = [];
        (0, each_1.default)(node.attributes, function (_a) {
            var name = _a.name, value = _a.value;
            return attributes_1.push(name, value);
        });
        ret.attributes = attributes_1;
    }
    var childNodes = filterNodes(node.childNodes);
    ret.childNodeCount = childNodes.length;
    var hasOneTextNode = ret.childNodeCount === 1 && childNodes[0].nodeType === 3;
    if (depth > 0 || hasOneTextNode) {
        ret.children = getChildNodes(node, depth);
    }
    return ret;
}
exports.wrap = wrap;
function getChildNodes(node, depth) {
    var childNodes = filterNodes(node.childNodes);
    return (0, map_1.default)(childNodes, function (node) { return wrap(node, { depth: depth - 1 }); });
}
exports.getChildNodes = getChildNodes;
function getPreviousNode(node) {
    var previousNode = node.previousSibling;
    if (!previousNode)
        return;
    while (!isValidNode(previousNode) && previousNode.previousSibling) {
        previousNode = previousNode.previousSibling;
    }
    if (previousNode && isValidNode(previousNode)) {
        return previousNode;
    }
}
exports.getPreviousNode = getPreviousNode;
function filterNodes(childNodes) {
    return filter_1.default(childNodes, function (node) { return isValidNode(node); });
}
exports.filterNodes = filterNodes;
function isValidNode(node) {
    if (node.nodeType === 1) {
        var className = node.getAttribute('class') || '';
        if ((0, contain_1.default)(className, '__chobitsu-hide__') ||
            (0, contain_1.default)(className, 'html2canvas-container')) {
            return false;
        }
    }
    var isValid = !(node.nodeType === 3 && (0, trim_1.default)(node.nodeValue || '') === '');
    if (isValid && node.parentNode) {
        return isValidNode(node.parentNode);
    }
    return isValid;
}
exports.isValidNode = isValidNode;
function getNode(nodeId) {
    var node = nodes.get(nodeId);
    if (!node || node.nodeType === 10) {
        throw (0, util_1.createErr)(-32000, 'Could not find node with given id');
    }
    return node;
}
exports.getNode = getNode;
